import {
  Box,
  Button,
  Grid
} from "@mui/material";
// import ImageUpload from '../../step-three/ImageUpload'

import CustomTextFiled from "components/CustomTextField";
import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useAppDispatch } from "store/appHooks";
import { Label, SubTitle, Title, TypeButton } from "../mui.styles";
const centerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const UsageRates = (props: any) => {
  const {
    currentStep,
    generalReducer,
    setCurrentStep,
    isMobileView,
    changeStepStatus,
    stepStatus
  } = props;
  const {
    setValue,
    control,
    watch,
    trigger,
    clearErrors,
    formState: { errors },
  } = useFormContext();
  const values = watch();
  const { usage_type } = values;
  const dispatch = useAppDispatch();
  const equipmentType = values?.equipmentType;

  const navigateNext = async () => {
    const res = await trigger([
      "custom_excess_hours_fee",
      "custom_hours",
      "usage_type",
    ]);
    if (res) {
      setCurrentStep("Pricing");
      changeStepStatus(currentStep, "submitted", true);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } 
    
  };

  useEffect(() => {
  
    setValue("custom_hours_unit", "day");
    setValue("custom_excess_hours_fee_unit", "hour");
  }, [setValue]);

  useEffect(() => {
    if (stepStatus[currentStep]?.error) {
      navigateNext();
    }
  }, [stepStatus[currentStep]?.error]);

  return (
    <Box sx={{ p: "10px 16px", ...(!isMobileView && { width: "100%" }) }}>
      <Title>Usage rates</Title>
      <SubTitle>
        Flexible and competitive usage rates for hassle-free equipment rentals
        to meet users specific needs.
      </SubTitle>
      <br />
      <Label>How would you like to set your usage rates?</Label>

      <br />
      <Box>
        <TypeButton
          color="primary"
          variant={usage_type == 1 ? "contained" : "outlined"}
          onClick={() => setValue("usage_type", 1)}
        >
          Allow unlimited usage
        </TypeButton>
        <TypeButton
          color="primary"
          variant={usage_type == 2 ? "contained" : "outlined"}
          onClick={() => setValue("usage_type", 2)}
        >
          Set my own rates
        </TypeButton>
      </Box>
      <br />
      {usage_type == 2 && (
        <Grid container spacing={3} width={"100%"}>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Controller
              control={control}
              name={"custom_hours"}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextFiled
                  inputValue={value}
                  label="Number of hours"
                  onInputChange={onChange}
                  showError={!!error}
                  errorMessage={error?.message || " "}
                  showEndDropDown={true}
                  dropDownValue={values?.custom_hours_unit}
                  dropDownOptions={[{ id: "day", name: "Per day" }]}
                  onDropDownChange={(v: any) => {
                    setValue("custom_hours_unit", v);
                  }}
                  inputProps={{type: "number"}}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Controller
              control={control}
              name={"custom_excess_hours_fee"}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextFiled
                  inputValue={value}
                  label="Excess hour fee"
                  onInputChange={onChange}
                  showError={!!error}
                  errorMessage={error?.message || " "}
                  showEndDropDown={true}
                  dropDownValue={values?.custom_excess_hours_fee_unit}
                  dropDownOptions={[{ id: "hour", name: "Per hrs" }]}
                  onDropDownChange={(v: any) => {
                    setValue("custom_excess_hours_fee_unit", v);
                  }}
                  inputProps={{type: "number"}}
                />
              )}
            />
          </Grid>
        </Grid>
      )}
      <Box display="flex" justifyContent="end" mt={3}>
        <Button
          sx={{
            mr: 1.5,

            backgroundColor: "transparent",
            color: "primary.main",
            border: "1px solid #dfdfdf",
          }}
          variant="contained"
          type="submit"
          onClick={() => setCurrentStep("Listing Images")}
        >
          Back
        </Button>
        <Button
          variant="contained"
          onClick={navigateNext}
          // disabled={listingReducer?.submittingListingData}
          // endIcon={
          //   listingReducer.submittingListingData ? (
          //     <CircularProgress size={15} />
          //   ) : null
          // }
        >
          Continue
        </Button>
      </Box>
    </Box>
  );
};

export default UsageRates;
